import FaqAccordion from "@/components/base/FaqAccordion";
import SectionHeading from "@/components/base/SectionHeading";
import { faqItems } from "@/mocks/site";

export default function FaqSection() {
  return (
    <section className="w-full bg-background-100" aria-label="常见问题">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[360px_1fr] lg:gap-14">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeading
              eyebrow="FAQ"
              title="常见问题"
              description="关于内容来源、叙述规范与更新机制，这里有最常被问到的几个问题。如果还有疑问，欢迎通过反馈表告诉我。"
            />
          </div>
          <FaqAccordion items={faqItems} />
        </div>
      </div>
    </section>
  );
}